export default __webpack_public_path__ + "static/media/like.c3f9802d.svg";